// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popover {
  max-width: unset;
  overflow: hidden;
  box-shadow: 4px 4px 4px 0px #CCCCCC;
}

.popover-container {
  width: 300px !important;
  padding: 0 !important;
  margin: 0 !important;
}

.popover-header {
  background-color: #283039 !important;
  color: white !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  padding: 10px !important;
  width: 100% !important;
  margin: 0 !important;
}

.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border: none;
}

.popover-body {
  width: 300px !important;
  position: relative;
  left: 0px !important;
  background-color: white !important;
  padding: 0 !important;
  margin: 0 !important;
}

.close-icon {
  cursor: pointer !important;
}

.popover .popover-arrow {
  display: none;
}

.popover-body {
  padding: 0;
}

.align-objects:hover {
  color: #2c92e6 !important;
  border-color: #2c92e6 !important;
}`, "",{"version":3,"sources":["webpack://./src/product/RightSideModal.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,kCAAkC;EAClC,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC","sourcesContent":[".popover {\n  max-width: unset;\n  overflow: hidden;\n  box-shadow: 4px 4px 4px 0px #CCCCCC;\n}\n\n.popover-container {\n  width: 300px !important;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.popover-header {\n  background-color: #283039 !important;\n  color: white !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: bold;\n  padding: 10px !important;\n  width: 100% !important;\n  margin: 0 !important;\n}\n\n.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  border: none;\n}\n\n.popover-body {\n  width: 300px !important;\n  position: relative;\n  left: 0px !important;\n  background-color: white !important;\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n.close-icon {\n  cursor: pointer !important;\n}\n\n.popover .popover-arrow {\n  display: none;\n}\n\n.popover-body {\n  padding: 0;\n}\n\n.align-objects:hover {\n  color: #2c92e6 !important;\n  border-color: #2c92e6 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
